/**
 * Created by TF on 2018/6/20
 */
import axios from 'axios'
let qs = require('qs');

let base = 'http://47.104.248.56:8081';

var instance = axios.create({
    headers: {
        // 'content-type': 'application/json',
        'Authorization': ''
    }
});
instance.interceptors.request.use(
    config => {
        config.headers.Authorization = sessionStorage.getItem('Authorization');
        return config
    }, err => {
        return Promise.reject(err)
    });

// 直接意向
// 借入意向添加
export const reqDirectBorrowIntentionAdd= params => {
    return instance.post(`${base}/directIntention/borrowAdd`, qs.stringify(params))
};
// 获取图片验证码是否正确。
export const reqDirectIntentionCodeImgIsTrue = params => { return instance.get(`${base}/directIntention/getDirectIntentionCodeImgIsTrue`, {params: params}) }

// 直接借入意向发送短信验证码
export const  reqDirectIntentionPhoneCaptcha= params => { return instance.get(`${base}/directIntention/getDirectIntentionPhoneCaptcha`, { params: params }) }

export const reqDirectBorrowIntentionCodeImg= () => {
    return instance.get(`${base}/directIntention/getDirectIntentionCodeImg`)
};
export const downloadFileURL = `${base}/file/downloadFile/`;
//通过code查询数据字典
export const reqGetDictionaryListByCode = params => { return instance.get(`${base}/dictionary/getListByCode`, { params: params } ) };

//出借意向添加
export const reqDirectLoanIntentionAdd = params => {
    return instance.post(`${base}/loanIntention/add`,qs.stringify(params))
};
//直接出借意向生成图形验证码
export const  reqDirectLanIntentionCodeImg= () => { return instance.get(`${base}/loanIntention/getLanIntentionCodeImg`) }
// 获取图片验证码是否正确。
export const reqDirectLanIntentionCodeImgIsTrue = params => { return instance.get(`${base}/loanIntention/getDirectLanIntentionCodeImgIsTrue`, {params: params}) }

// 直接出借意向发送短信验证码
export const  reqDirectLanIntentionPhoneCaptcha= params => { return instance.get(`${base}/loanIntention/getDirectLanIntentionPhoneCaptcha`, { params: params }) }

//项目意向
// 借入意向新增
export const reqBorrowIntentionAdd = params => { return instance.post(`${base}/borrowIntention/add`, qs.stringify(params) ) };
// 根据项目id查询借入意向
export const reqQueryBorrowIntentionByProjId = params => { return instance.get(`${base}/borrowIntention/queryByProjId`, { params: params } ) };
// 查询是否有未处理的意向
export const reqQueryUnprocessedIntention = params => { return instance.get(`${base}/borrowIntention/hasUnprocessedIntention`, { params: params } ) };
// 根据项目id查询借入意向 分页
export const reqGetBorrowIntentionByProjIdPage = params => { return instance.get(`${base}/borrowIntention/queryByProjIdPage`, { params: params } ) };

// 出借意向新增
export const reqLoanIntentionAdd = params => { return instance.post(`${base}/pLoanIntention/add`, qs.stringify(params) ) };
// 根据项目id查询出借意向
export const reqQueryLoanIntentionByProjId = params => { return instance.get(`${base}/pLoanIntention/queryByProjId`, { params: params } ) };
// 根据项目id查询出借意向 分页
export const reqGetLoanIntentionByProjIdPage = params => { return instance.get(`${base}/pLoanIntention/queryByProjIdPage`, { params: params } ) };

// 债权转让意向新增
export const reqAssignmentIntentionAdd = params => { return instance.post(`${base}/assignmentIntention/add`, qs.stringify(params) ) };
// 根据项目id查询债权转让意向
export const reqQueryAssignmentIntentionByProjId = params => { return instance.get(`${base}/assignmentIntention/queryByProjId`, { params: params } ) };
// 根据项目id查询债权转让意向 分页
export const reqGetAssignmentIntentionByProjIdPage = params => { return instance.get(`${base}/assignmentIntention/queryByProjIdPage`, { params: params } ) };




// WEBPACK FOOTER //
// ./src/api/intentionManagement-api.js